import React, {
  ChangeEvent,
  FunctionComponent,
  useCallback,
  useState,
} from 'react';

import {
  BEDROOM_NUMBER_OPTIONS,
  SingleFieldStepProps,
} from 'scenes/common/types';
import { SegmentedControlQuestion } from 'scenes/common/components/Questions';
import { filterOptionsToDisplay } from 'scenes/common/helpers/expandableOptionDisplay';
import { useForm } from 'react-hook-form';
import { SaveEmailSubmitButtonGroup } from 'components';

const STATE_KEY = 'numberOfBedrooms';
export const QUESTION = 'How many bedrooms does it have, including studies?';

const NumberOfBedroomsStep: FunctionComponent<Pick<
  SingleFieldStepProps<number>,
  'defaultStateValue' | 'onNext'
>> = ({ defaultStateValue, onNext }) => {
  const NUM_OPTIONS_TO_DISPLAY = 5;
  const [showAll, setShowAll] = useState(
    BEDROOM_NUMBER_OPTIONS.length <= NUM_OPTIONS_TO_DISPLAY
  );

  // Unique value!
  const SHOW_MORE_OPTION = {
    label: 'Show more',
    value: BEDROOM_NUMBER_OPTIONS.length + 1,
  };

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>, onChange: Function): void => {
      const optionValue = (event.target.value as unknown) as number;
      onChange(event);

      if (optionValue === SHOW_MORE_OPTION.value) {
        setShowAll(true);
      }
    },
    [SHOW_MORE_OPTION.value]
  );

  const extractOptionByValue = (value: number) =>
    BEDROOM_NUMBER_OPTIONS.find((option) => option.value === value);

  const { handleSubmit, control, errors, formState: hooksForm } = useForm({
    mode: 'onChange',
    criteriaMode: 'all',
  });

  return (
    <form onSubmit={handleSubmit(onNext)}>
      <SegmentedControlQuestion
        errors={errors}
        control={control}
        stateKey={STATE_KEY}
        options={
          showAll
            ? BEDROOM_NUMBER_OPTIONS
            : filterOptionsToDisplay(
                BEDROOM_NUMBER_OPTIONS,
                SHOW_MORE_OPTION,
                NUM_OPTIONS_TO_DISPLAY,
                extractOptionByValue(defaultStateValue)
              )
        }
        defaultValue={defaultStateValue}
        changeHandler={handleChange}
        question={QUESTION}
        validationRules={{
          validate: {
            oneOf: (value: number) =>
              BEDROOM_NUMBER_OPTIONS.some((option) => option.value === value),
          },
        }}
      />
      <SaveEmailSubmitButtonGroup submitEnabled={hooksForm.isValid} />
    </form>

    /*
    <SingleSegmentedControlStep
      onNext={onNext}
      question={QUESTION}
      stateKey={STATE_KEY}
      options={
        showAll
          ? BEDROOM_NUMBER_OPTIONS
          : filterOptionsToDisplay(
              BEDROOM_NUMBER_OPTIONS,
              { label: '1', value: 1 },
              extractOptionByValue,
              NUM_OPTIONS_TO_DISPLAY
            )
      }
      onChange={handleChange}
      defaultStateValue={defaultStateValue}
      validationRules={{
        validate: {
          oneOf: (value: number) =>
            BEDROOM_NUMBER_OPTIONS.some((option) => option.value === value),
        },
      }}
    /> */
  );
};
export default NumberOfBedroomsStep;
